export default [
    {
        path: '/',
        meta: {},
        component: () => import('@/views/144/index')
    },
]

